import React from "react";
import { useFieldArray } from "react-hook-form";
import Input from "../Input/Input";
import TopLabelCustomSelectBox from "../TopLabelReactSelect/TopLabelReactSelect";
import { StatusOptions } from "../../utils/constants";
import styles from "./AcademicActivites.module.css";

const ThesisSupervision = ({ register, control, errors, disabled }) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "thesisSupervision",
  });

  React.useEffect(() => {
    if (fields.length === 0) {
      append({
        level: "",
        title: "",
        status: "",
        year: "",
      });
    }
  }, [fields, append]);

  return (
    <div>
      <div className={styles.heading}>
        <div>
          <h2>
            <strong>Research Projects</strong>
          </h2>

          <h2>A. Thesis Supervision / Guidance</h2>
        </div>{" "}

      </div>
      {fields.map((item, idx) => (
        <div className={styles.grid4} key={item.id}>
          <Input
            label="Level"
            name={`thesisSupervision[${idx}].level`}
            register={register}
            errors={errors}
            disabled={disabled}
          />
          <Input
            label="Title"
            name={`thesisSupervision[${idx}].title`}
            register={register}
            errors={errors}
            disabled={disabled}
          />
          <TopLabelCustomSelectBox
            label="Status"
            name={`thesisSupervision[${idx}].status`}
            register={register}
            errors={errors}
            placeholder="Select"
            options={StatusOptions}
            control={control}
            disabled={disabled}
          />
          <Input
            label="Year"
            name={`thesisSupervision[${idx}].year`}
            register={register}
            errors={errors}
            year
            disabled={disabled}
          />

          {idx > 0 && !disabled && (
            <button
              type="button"
              className={styles.remove}
              onClick={() => remove(idx)}
            >
              X
            </button>
          )}
        </div>
      ))}
      <div className={styles.buttonOuter}>
        <div></div>
        {!disabled && (
          <button
            type="button"
            className={styles.button}
            onClick={() =>
              append({
                level: "",
                title: "",
                status: "",
                year: "",
              })
            }
          >
            + Add More
          </button>
        )}
      </div>
    </div>
  );
};

export default ThesisSupervision;
